import React from "react"

import { useApiContext } from "~/api"
import { DocumentType } from "~/api/types/DocumentsElements"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { Cell, TopCell } from "../Cells/Cells"
import styles from "./index.module.css"

type DocsByRubric = {
  rubric: string
  docs: DocumentType[]
  order: string
}

export const Rubrics: React.FC = () => {
  const { items } = useApiContext("/documents/elements")

  if (!items || items.length === 0) {
    return null
  }

  const reducedDocsByRubric = items
    .reduce((prev: DocsByRubric[], curr) => {
      const rubric = curr.rubric ? curr.rubric.trim() : curr.rubric
      const currentRubric = prev.find((el) => el.rubric === rubric)

      if (!currentRubric) {
        prev.push({ rubric: rubric, docs: [curr], order: curr.rubricSort })
      } else {
        prev.find((el) => el === currentRubric)?.docs.push(curr)
      }

      return prev
    }, [])
    .sort((a, b) => (a.order < b.order ? -1 : 1))

  return (
    <div className={styles.Wrapper}>
      {reducedDocsByRubric.map(({ rubric, docs }) => (
        <div key={rubric} className={styles.Items}>
          {rubric && (
            <Heading as="div" className={styles.Quarter} like="h2">
              <Raw html={rubric} />
            </Heading>
          )}

          <TopCell />

          {docs.map(({ id, date, file, link, name }) => (
            <Cell key={id} date={date} file={file} link={link} name={name} />
          ))}
        </div>
      ))}
    </div>
  )
}
